import type { IdArg } from '@/api/types'
import type { Company } from '@/api/types/hor'
import { COUPANG_SLUGS } from '@/constants/hor'
import type { AccommodationFormData } from '@/pages/accommodation/types'
import type { BaseOptionType } from '@/UIkit/Select'

import { useCompany } from './useCompany'

import type { Path, UseFormWatch } from 'react-hook-form'

const COUPANG_ID = 445

export const checkIsCoupang = ({
  rmcId,
  company,
}: {
  rmcId?: IdArg
  company?: Company
}) => rmcId === COUPANG_ID || COUPANG_SLUGS.includes(company?.slug)

export const useIsCoupang = (watch: UseFormWatch<AccommodationFormData>) => {
  const company = useCompany(watch as UseFormWatch<AccommodationFormData>)
  const rmc = watch(
    'company.value' as Path<AccommodationFormData>
  ) as BaseOptionType<Number>

  return checkIsCoupang({ rmcId: Number(rmc?.value), company })
}
